import { FC } from 'react'
import { Notes } from '../../../types/items/'

export const PDFNotesItem: FC<{ item: Notes; date: Date }> = ({
  item,
  date,
}) => {
  return null
}
